import { NgModule }                         from '@angular/core';
import { CommonModule }                     from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule }             from '@angular/material/progress-bar';
import { TextFieldModule }                  from '@angular/cdk/text-field';
import { A11yModule }                       from '@angular/cdk/a11y';
import { MatTooltipModule }                 from '@angular/material/tooltip';

import { PipesModule } from '@shared/pipes/pipes.module';
import { IconsModule } from '@shared/icons/icons.module';

import { EditorImageComponent }    from '@shared/editor/editor-image/editor-image.component';
import { EditorMarkFormComponent } from '@shared/editor/editor-mark-form/editor-mark-form.component';
import { EditorMarkComponent }     from '@shared/editor/editor-mark/editor-mark.component';
import { EditorMarkInfoComponent } from './editor-mark-info/editor-mark-info.component';
import { EditorTextComponent }     from './editor-text/editor-text.component';


@NgModule({
  declarations: [
    EditorImageComponent,
    EditorMarkFormComponent,
    EditorMarkComponent,
    EditorMarkInfoComponent,
    EditorTextComponent
  ],
  imports: [
    CommonModule,
    // MatInputModule,
    MatProgressBarModule,
    // MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    IconsModule,
    TextFieldModule,
    A11yModule,
    MatTooltipModule,
  ],
  exports:      [
    EditorImageComponent,
    EditorMarkFormComponent,
    EditorMarkComponent,
    EditorMarkInfoComponent,
    EditorTextComponent
  ]
})
export class EditorModule {}
